import React from 'react'
import "../../Styles/Loading/Loading.css"
function Loading() {
    return (
      <div className="loading flexBox">
        <div className="loader flexBox">
          <div className="bounce1 bounce"></div>
          <div className="bounce2 bounce"></div>
          <div className="bounce3 bounce"></div>
          <div className="bounce4 bounce"></div>
          <div className="bounce5 bounce"></div>
        </div>
      </div>
    );
}

export default Loading
